import { Component, OnInit } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { ActivatedRoute, ActivationEnd, Router } from "@angular/router";
import { ApsServiceService } from "../aps-service.service";
import * as $ from 'jquery';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: "app-onlineshop",
  templateUrl: "./onlineshop.component.html",
  styleUrls: ["./onlineshop.component.css"],
})
export class OnlineshopComponent implements OnInit {
  loaderdata:any=false
  dataexist: any = false;
  data: any = "";
  pages: any = "";
  next: any = "";
  previous: any = "";
  first: any = "";
  last: any = "";
  limit: any = 1;
  eventspage: any = "";
  eventpagenumber: any;
  unamePattern:any = "^[a-z0-9_-]{8,15}$"; 
  cart_count:any;
  cartdatas:any;
  carttotoal:any=0;
  condition:any=false;
  getuserinfo: number;

  constructor(
    private routepage: Router,
    private route: ActivatedRoute,
    private searchitem: ApsServiceService,
    private sanitizer: DomSanitizer,
    private toastr: ToastrService,
    private routerItem: Router,

  ) {}

  ngOnInit(): void {

    if(localStorage.getItem("userid")){
      this.getuserinfo=1
    }else{
      this.getuserinfo=0

    }

    this.getshopitems()

    this.routerItem.events.subscribe(event =>{
      //console.log(event)
      //  this.geeventlist();

      if (event instanceof ActivationEnd){
   		//console.log("navigation start");
       this.getshopitems();
      }
    })
  }
  getshopitems(){
   
    this.loaderdata=true
    if(localStorage.getItem("key") !== null  ){
      this.condition=true
    var lists:any[] = JSON.parse(localStorage.getItem("key"))
    this.cart_count=lists.length;
    //console.log(lists)
    this.cartdatas=lists
    this.carttotoal=localStorage.getItem("totalCart")
    this.condition=true
    }
   
    this.eventpagenumber = this.route.snapshot.params.page;
    //console.log(this.eventpagenumber);
    //console.log(this.route.snapshot.params.eventname);
    this.eventspage = this.route.snapshot.params.eventname;

    this.searchitem.product(this.eventpagenumber).subscribe((responce) => {
      
      if (responce.status) {
        this.dataexist = true;
        this.pages = parseInt(responce.totalitems);
        this.last = Math.ceil(this.pages / this.limit);

        if (responce.next) {
          this.next = parseInt(responce.next);
        }else{
          this.next=0
        }
        if (responce.previous) {
          this.previous = parseInt(responce.previous);
        }else{
          this.previous=0
        }

        //console.log(responce.totalitems);
        //  this.data = this.sanitizer.bypassSecurityTrustHtml(responce.data[0].event_details);
        this.data = responce.data;
        //console.log(this.data)
        this.loaderdata=false
        
      } else {
        this.dataexist = false;
        this.loaderdata=false
        
      }
    });
    this.loaderdata=true;
  }

  onClickSubmit(datas){
    //console.log(datas)


    var listcart=[]


    if (localStorage.getItem("key") !== null) {
      //...
      //console.log('not null')
      //console.log(localStorage.getItem("key"));
      var listcart:any[] = JSON.parse(localStorage.getItem("key"))
      //console.log(listcart)
    
    }
    //console.log(localStorage.getItem("key"));
    // getusername:any=localStorage.getItem('username');
    //console.log(datas.shop_rate)
   if(!datas.shop_rate){
     //console.log("error")
    this.toastr.warning("YOU MUST MAKE A SELECTION")
   }else{

    var string = datas.shop_rate;
    var liststring = string.split(" ");
    var price=liststring[0]


   var cartid = listcart.length
   //console.log(cartid)
   cartid=cartid+1
    
     var cartitem={
       "cartid":cartid,
       "cartname":datas.shophead,
       "quantity":1,
       "total_cartprice":price,
       "cartprice":price

     }

     listcart.push(cartitem);
     //console.log(listcart)

     //console.log(listcart)
      localStorage.setItem('key',JSON.stringify(listcart))
      this.cart_count=cartid
      this.cartdatas=listcart
      this.carttotoal=0
      this.condition=true
      for(let i=0; i< listcart.length;i++){
        //console.log(listcart[i].total_cartprice)
        this.carttotoal = parseFloat(this.carttotoal)+ parseFloat(listcart[i].total_cartprice)
        //console.log(this.carttotoal )
      }
      this.carttotoal=this.carttotoal.toFixed(2)
      localStorage.setItem('totalCart',this.carttotoal)
      //console.log(this.carttotoal)
  
   } 

  }


  getitems(datas){
    //console.log(datas)
    if(!datas.shop_rate){
      //console.log("error")
     this.toastr.warning(" YOU MUST MAKE A SELECTION")
    }else{
      this.loaderdata=true;

    var string = datas.shop_rate;
    var liststring = string.split(" ");
    var price=liststring[0]
    //console.log(price);

    var placelist = liststring.splice(1);
    var place  = placelist.join(' ');

    //console.log('split')
//console.log(place);


var payloader=[]
  var dataset={}
  dataset["name"]=datas.shophead
  dataset["sku"]=1
  dataset["price"]=parseFloat(price)
  
  dataset["currency"]="USD"
  dataset["quantity"]=1
  payloader.push(dataset)

localStorage.setItem('storedcart',JSON.stringify(payloader))

var payments={
  "currency": "USD",
  "total": parseFloat(price)
}
//console.log(payloader)
//   [{
//     "name": "Red Sox Hat",
//     "sku": "001",
//     "price": "5.00",
//     "currency": "USD",
//     "quantity": 1
// }]
//console.log(payloader)

//console.log(payments)
  this.searchitem.payment(payments,payloader).subscribe((responce)=>{
  //console.log(responce.data)
  this.loaderdata=false
  localStorage.setItem("shoppaymets","true")
  localStorage.setItem("productplace",place)
  localStorage.setItem('totalCart',price)


  window.location.href=responce.data;

  // this.routerItem.navigate([responce.data])
  

  })

    }
    



// var a = "asdasd|dasd|rttewrtert";
// var b = a.split('|');
// // ["asdasd", "dasd", "rttewrtert"]
// var c = b.splice(1);
// // ["dasd", "rttewrtert"]
// var d = c.join(' ');
// //console.log(d)
// // dasdrttewrtert

  }

  updatecart(cart){
    //console.log(cart)
    // var num="123456"
    // const reg = new RegExp('^\d+$')
    // //console.log(reg.(num))



    if(cart.quanty !== NaN || cart.quanty != ""){

      var ticket =  cart.quanty;
      //console.log(ticket)
      var reg = new RegExp('^[0-9]*$');
      //console.log(cart)
      if (reg.test(ticket)==true) {
  


    var lists:any[] = JSON.parse(localStorage.getItem("key"))
    var lenthofitem=lists.length
    for(let i=0; i < lenthofitem ; i++){
      if(lists[i].cartid == cart.shopids){
      //console.log(lists[i])
      var cartitemprice =lists[i].cartprice
      cartitemprice =parseFloat(cartitemprice)* parseInt(cart.quanty)
      //console.log(cartitemprice)
      lists[i].quantity=parseInt(cart.quanty)
      lists[i].total_cartprice= parseFloat(cartitemprice).toFixed(2); 
    } 
    localStorage.setItem('key',JSON.stringify(lists))
    //console.log(lists)
    this.cartdatas=lists
    this.carttotoal=0;
    for(let i=0; i< lists.length;i++){
      //console.log(lists[i].total_cartprice)
      this.carttotoal = parseFloat(this.carttotoal) + parseFloat(lists[i].total_cartprice)
      //console.log(this.carttotoal)
    }
    this.carttotoal=this.carttotoal.toFixed(2)
    localStorage.setItem('totalCart',this.carttotoal)
  
    
  }
}
else{
  this.toastr.error('Charater not Support')
}
} 
else{
//console.log("null")
}
  
}

removeCart(cartid){
  var lists:any[] = JSON.parse(localStorage.getItem("key"));
  var listitem=[];


  for(let i = 0;i<lists.length;i++){
   
    if(lists[i].cartid != cartid){
     //console.log(lists[i])
     listitem.push(lists[i])
   

  }
  }
  //console.log(listitem)
  localStorage.setItem('key',JSON.stringify(listitem))
  this.cartdatas=listitem;
  if(listitem.length){
    this.carttotoal=0;
    this.cart_count=listitem.length;
  for(let i=0; i< listitem.length;i++){
    //console.log(listitem[i].total_cartprice)
    this.carttotoal = this.carttotoal + parseInt(listitem[i].total_cartprice)
    //console.log(this.carttotoal )
  }
  localStorage.setItem('totalCart',this.carttotoal)

}else{
  this.carttotoal=0
  localStorage.setItem('totalCart','0')
  this.cart_count=0
  localStorage.removeItem('key');
}

}

removeall(){
  //console.log("all removie")
  this.carttotoal=0
  localStorage.setItem('totalCart','0')
  localStorage.removeItem('key');
  this.cart_count=0
  this.cartdatas=[]
}

payment(){
  this.loaderdata=true;
  //console.log(localStorage.getItem("key"))
  var datas=JSON.parse(localStorage.getItem("key"))
  var lengths=datas.length
  //console.log(lengths)
  //console.log(datas)
var payloader=[]
for(let i=0;i<lengths;i++){
  //console.log(i)
  var dataset={}
  dataset["name"]=datas[i].cartname
  dataset["sku"]=datas[i].cartid
  dataset["price"]=parseFloat(datas[i].cartprice)
  dataset["currency"]="USD"
  dataset["quantity"]=datas[i].quantity
  payloader.push(dataset)
}
var itemss=parseFloat(localStorage.getItem("totalCart"));
localStorage.setItem('storedcart',JSON.stringify(payloader))

var payments={
  "currency": "USD",
  "total": itemss
}
//console.log(payloader)
//   [{
//     "name": "Red Sox Hat",
//     "sku": "001",
//     "price": "5.00",
//     "currency": "USD",
//     "quantity": 1
// }]
//console.log(payloader)
  this.searchitem.payment(payments,payloader).subscribe((responce)=>{
  //console.log(responce.data)
  this.loaderdata=false
  localStorage.setItem("shoppaymets","true")
  window.location.href=responce.data;

  // this.routerItem.navigate([responce.data])
  

  })

}

}